import {AppState} from '../../index';

export const molodayaArcticaSelector = (state: AppState) => state.molodayaArctica.data;

export const molodayaArcticaLoadingSelector = (state: AppState) => state.molodayaArctica.dataLoading;
